import { type Href, router } from 'expo-router';
import React from 'react';
import {
    BodySmallEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    YStack,
} from 'smoothie';

import { AuxContainer } from './GroveContainers';

interface FullScreenErrorProps {
    hasBackButton?: boolean;
    message?: string;
    buttonLabel?: string;
    fallbackRoute?: Href;
    resetError?: () => void;
}

const FullScreenError = ({
    hasBackButton = true,
    message,
    buttonLabel,
    fallbackRoute,
    resetError,
}: FullScreenErrorProps) => {
    return (
        <AuxContainer>
            <YStack
                alignItems="center"
                padding={32}
                flexGrow={1}
                width="100%"
                marginTop="40vh"
            >
                <BodySmallEmphasized color="$red1100">
                    {message ?? 'Oops! Something went wrong.'}
                </BodySmallEmphasized>
                {hasBackButton && (
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text={buttonLabel ?? 'Go back'}
                        marginTop="10vh"
                        buttonProps={{ maxWidth: 400 }}
                        onPress={() => {
                            if (resetError) {
                                resetError();
                            }

                            if (router.canGoBack()) {
                                router.back();
                            } else {
                                router.replace((fallbackRoute as Href) ?? '/');
                            }
                        }}
                    />
                )}
            </YStack>
        </AuxContainer>
    );
};

export default FullScreenError;
